import { Create, useForm, useSelect } from "@refinedev/antd";
import { Form, Input, Tag, Select, Space, Row, Col } from "antd";
import { IResourceComponentsProps } from "@refinedev/core";
import { UserOutlined, PhoneOutlined, LinkOutlined } from "@ant-design/icons";

import { IContact, IShipco, IShipcoGroup, IVessel } from "interfaces";
import { FormSection, FormFieldGrid } from "components/form";

export const ContactCreate: React.FC<IResourceComponentsProps> = () => {
  const {
    formProps,
    saveButtonProps,
    formLoading: isLoading,
  } = useForm<IContact>({ redirect: "list" });

  const { selectProps: shipcoSelectProps } = useSelect<IShipco>({
    resource: "shipco",
    optionLabel: "registrationName",
    optionValue: "id",
    pagination: { mode: "server" }
  });

  const { selectProps: shipcoGroupSelectProps } = useSelect<IShipcoGroup>({
    resource: "shipco-group",
    optionLabel: "registrationName",
    optionValue: "id",
    pagination: { mode: "server" }
  });

  const { selectProps: vesselSelectProps } = useSelect<IVessel>({
    resource: "vessel",
    optionLabel: "name",
    optionValue: "id",
    pagination: { mode: "server" }
  });

  return (
    <Create
      breadcrumb={false}
      saveButtonProps={saveButtonProps}
      headerProps={{
        onBack: () => window.history.back(),
        subTitle: "setup new contact",
        tags: isLoading ? (
          <Tag color="orange">loading</Tag>
        ) : (
          <Tag color="green">live</Tag>
        ),
      }}
    >
      <Form {...formProps} layout="vertical">
        <Space direction="vertical" size={24} style={{ width: "100%" }}>
          <FormSection
            title="Contact Information"
            subtitle="Personal details"
            icon={<UserOutlined />}
            variant="elevated"
          >
            <FormFieldGrid columns={2}>
              <Form.Item
                label="Contact Name"
                name="name"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </FormFieldGrid>
          </FormSection>

          <Row gutter={24}>
            <Col xs={24} lg={12}>
              <FormSection
                title="Contact Details"
                subtitle="Communication information"
                icon={<PhoneOutlined />}
              >
                <Form.Item
                  label="Email"
                  name="email"
                  rules={[{ required: true }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Phone"
                  name="phone"
                  rules={[{ required: true }]}
                >
                  <Input />
                </Form.Item>
              </FormSection>
            </Col>

            <Col xs={24} lg={12}>
              <FormSection
                title="Associations"
                subtitle="Link to entities (optional)"
                icon={<LinkOutlined />}
              >
                <Form.Item label="Shipco" name={["shipco", "id"]}>
                  <Select {...shipcoSelectProps} />
                </Form.Item>
                <Form.Item label="Shipco Group" name={["shipcoGroup", "id"]}>
                  <Select {...shipcoGroupSelectProps} />
                </Form.Item>
                <Form.Item label="Vessel" name={["vessel", "id"]}>
                  <Select {...vesselSelectProps} />
                </Form.Item>
              </FormSection>
            </Col>
          </Row>
        </Space>
      </Form>
    </Create>
  );
};
